import axios from "axios";
import { API_URL } from "../config/axiosConfig";

export const apiCreateCollector = (payload, token) =>
  axios.post(`${API_URL}/v1/collector/add`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetCollector = (token) =>
  axios.get(`${API_URL}/v1/collectors/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetActiveCollector = (token) =>
  axios.get(`${API_URL}/v1/collectors?isActive=true`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetCollectorById = (token, id) =>
  axios.get(`${API_URL}/v1/collectors/id/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiUpdateCollector = (token, payload) =>
  axios.put(`${API_URL}/v1/collector/update`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiTransferCollectorCustomers = (
  token,
  oldCollectorId,
  newCollectorId
) =>
  axios.post(
    `${API_URL}/v1/collector/transferAssignedCustomers/oldCollectorId/${oldCollectorId}/newCollectorId/${newCollectorId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
